export default __webpack_public_path__ + "static/media/pour-wine.3306aa83.jpg";